import * as React from 'react';
import s from './allArticles.scss';
import ArticleView from '../ArticleView';

type AllArticlesProps = {
  articles: any[],
  experiments?: any[]
};

class AllArticles extends React.Component<AllArticlesProps, {}> {
  private renderArticles(articles, experiments) {
    return articles.map(article => (
      <ArticleView
        article={article}
        key={article.id}
        experiments={experiments}
      />
    ));
  }
  render() {
    const {articles, experiments = []} = this.props;

    return (
      <ul className={s.layout}>
        {this.renderArticles(articles, experiments)}
      </ul>);
  }
}
export default AllArticles;
